import { apiUrl } from '../api/config'
import carsImage from '@/assets/images/categories/cars.gif'
import carsImageRest from '@/assets/images/categories/rest/cars.gif'
import carsImageStatic from '@/assets/images/categories/static/cars-frame.gif'
import copierImage from '@/assets/images/categories/copier.gif'
import copierImageRest from '@/assets/images/categories/rest/copier.gif'
import copierImageStatic from '@/assets/images/categories/static/copier-frame.gif'
import othersImage from '@/assets/images/categories/others.gif'
import othersImageRest from '@/assets/images/categories/rest/others.gif'
import othersImageStatic from '@/assets/images/categories/static/others-frame.gif'
import phonesImage from '@/assets/images/categories/phones.gif'
import phonesImageRest from '@/assets/images/categories/rest/phones.gif'
import phonesImageStatic from '@/assets/images/categories/static/phones-frame.gif'
import planesImage from '@/assets/images/categories/planes.gif'
import planesImageRest from '@/assets/images/categories/rest/planes.gif'
import planesImageStatic from '@/assets/images/categories/static/planes-frame.gif'
import publicationsImage from '@/assets/images/categories/publications.gif'
import publicationsImageRest from '@/assets/images/categories/rest/publications.gif'
import publicationsImageStatic from '@/assets/images/categories/static/publications-frame.gif'
import radiosImage from '@/assets/images/categories/radios.gif'
import radiosImageRest from '@/assets/images/categories/rest/radios.gif'
import radiosImageStatic from '@/assets/images/categories/static/radios-frame.gif'
import telegraphsImage from '@/assets/images/categories/telegraphs.gif'
import telegraphsImageRest from '@/assets/images/categories/rest/telegraphs.gif'
import telegraphsImageStatic from '@/assets/images/categories/static/telegraphs-frame.gif'
import typewritersImage from '@/assets/images/categories/typewriters.gif'
import typewritersImageRest from '@/assets/images/categories/rest/typewriters.gif'
import typewritersImageStatic from '@/assets/images/categories/static/typewriters-frame.gif'

export const initialState = {
  apiPath: apiUrl,
  apiAuthPath: apiUrl + 'authorized/',
  dataLoaded: false,
  isLoggedIn: false,
  loginErrors: false,
  isRegistered: false,
  registerErrors: false,
  loggedUserId: null,
  isFullscreen: false,
  iframeFullscreen: false,
  isNewsletterSignin: false,
  newsletterErrors: false,
  authToken: '',
  clipboardItems: [],
  ui: {
    mainNavOpen: true,
    pageNavOpen: false,
    fontSize: 0,
    fontSizeMin: 0,
    fontSizeMax: 1,
    contrast: false,
    breakpoint: '',
    windowWidth: 0,
    gifsLoaded: false,
    disableScrolls: false
  },
  mainData: {
    foundation: {
      title: '',
      hero: {
        header: '',
        description: ''
      },
      section2: {
        headers: [
          {
            header: '',
            description: ''
          }
        ],
        image: '',
        items: []
      },
      section3: {
        header: '',
        description: '',
        items: [
          {
            header: '',
            text: '',
            link: {
              page: '',
              label: '',
              icon: ''
            }
          }
        ]
      },
      section4: {
        headers: [
          {
            header: '',
            description: ''
          }
        ],
        image: ''
      },
      section5: {
        header: '',
        description: '',
        image: ''
      },
      section6: {
        header: '',
        items: []
      },
      section7: {
        headers: [
          {
            header: '',
            description: '',
            caption: ''
          }
        ],
        image: ''
      }
    },
    museum: {
      title: '',
      hero: {
        header: '',
        description: '',
        items: []
      },
      events: {
        header: '',
        items: [
          {
            header: '',
            subheader: '',
            subheader2: '',
            description: '',
            image: ''
          }
        ]
      },
      sectionHeart: {
        header: '',
        description: '',
        image: ''
      },
      tiles: [
        {
          header: '',
          description: ''
        }
      ],
      edifice: [
        {
          header: '',
          description: '',
          list: [],
          image: '',
          icon: ''
        }
      ],
      gallery: {
        header: '',
        description: '',
        items: []
      },
      why: {
        header: '',
        description: '',
        image: ''
      },
      road: {
        description: '',
        caption: '',
        items: [],
        image: ''
      },
      stages: {
        header: '',
        items: [
          {
            label: '',
            image: '',
            header: '',
            description: ''
          }
        ]
      },
      quote: {
        text: '',
        author: ''
      }
    },
    settings: {
      availableTranslations: ['pl', 'en'],
      selectedTranslation: ((navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage)).substring(0, 2) === 'pl' ? 'pl' : 'en')
    },
    virtual: {
      title: '',
      categories: {
        'telefony': {
          header: 'telefony',
          description: ''
        },
        'kopiarki': {
          header: 'kopiarki',
          description: ''
        },
        'maszyny-do-pisania': {
          header: 'maszyny do pisania',
          description: ''
        },
        'pojazdy': {
          header: 'pojazdy',
          description: ''
        },
        'samoloty': {
          header: 'samoloty',
          description: ''
        },
        'telegrafy': {
          header: 'telegrafy',
          description: ''
        },
        'radia': {
          header: 'radia',
          description: ''
        },
        'wydawnictwa': {
          header: 'wydawnictwa',
          description: ''
        },
        'inne': {
          header: 'inne',
          description: ''
        }
      },
      popup: {
        'title': '',
        'description': '',
        'descriptionAddon': '',
        'closeLink': ''
      },
      info: ''
    },
    centrum: {
      'title': '',
      'top': {
        'quote': {
          'text': '',
          'author': ''
        },
        'header': ''
      },
      'intro': {
        'akademia': {
          'title': '',
          'text': ''
        },
        'laboratorium': {
          'title': '',
          'text': ''
        }
      },
      'steam': [],
      'cele': {
        'title': '',
        'items': []
      },
      'columns': {
        'komunikacja': {
          'title': '',
          'text': ''
        },
        'kreatywnosc': {
          'title': '',
          'text': ''
        }
      },
      'footer': {
        'quote': {
          'text': '',
          'author': ''
        },
        'oferta': {
          'title': '',
          'text': ''
        }
      },
      'sections': [],
      'course-params': []
    },
    footer: {
      header: '',
      listItems: [
        {
          header: '',
          description: '',
          slug: ''
        }
      ],
      links: [
        {
          header: '',
          slug: ''
        }
      ],
      addres: {
        header: '',
        subheader: '',
        description: []
      },
      socials: {
        header: '',
        items: [
          {
            name: '',
            iconPath: '',
            url: ''
          }
        ]
      },
      newsletter: {
        header: '',
        placeholder: '',
        submit: '',
        thanks: ''
      },
      copy: {
        design: '',
        implementation: '',
        text: ''
      }
    },
    search: {
      results: {
        itemsFound: '',
        nothingFound: ''
      },
      input: {
        placeholder: '',
        button: ''
      },
      filter: {
        header: '',
        placeholder: '',
        noResults: '',
        button: '',
        toggleLabel: '',
        toggleLabelActive: ''
      }
    },
    product: {
      single: {
        loading: {
          header: '',
          text: ''
        },
        notfound: {
          header: '',
          text: '',
          linkLabel: ''
        },
        msg: {
          header: '',
          placeholder: '',
          button: '',
          addFiles: ''
        },
        fullScreenAlert: ''
      },
      gallery: {
        title: '',
        more: ''
      }
    },
    contact: {
      headers: [
        {
          header: '',
          description: ''
        }
      ],
      items: [],
      emailNotification: {
        placeholder: '',
        button: '',
        acceptTerms: '',
        acceptTermsLink: ''
      },
      form: {
        header: '',
        progressMsg: '',
        successMsg: '',
        errorMsg: '',
        msg: {
          placeholder: ''
        },
        input: {
          placeholder: '',
          name: '',
          surname: '',
          email: ''
        },
        accept: {
          terms: '',
          termsLink: '',
          gdpr: ''
        },
        button: ''
      }
    },
    login: {
      header: '',
      button: '',
      required: '',
      lostPass: '',
      lostPassLink: '',
      registerText: '',
      registerLink: '',
      addonText: '',
      input: {
        name: '',
        namePlaceholder: '',
        password: '',
        passPlaceholder: ''
      },
      passReset: {
        header: '',
        description: ''
      }
    },
    register: {
      header: '',
      button: '',
      addonText: '',
      input: {
        name: '',
        namePlaceholder: '',
        lastname: '',
        lastnamePlaceholder: '',
        email: '',
        emailPlaceholder: '',
        password: '',
        passwordPlaceholder: '',
        passwordConfirm: '',
        passwordConfirmPlaceholder: ''
      },
      confirmation: ''
    },
    error: {
      title: '',
      emptyMsg: '',
      emptyName: '',
      emptyEmail: '',
      incorrectEmail: '',
      noApproval: '',
      incorrectLogin: '',
      incorrectPass: '',
      networkError: '',
      tryAgain: '',
      pageNotFound: {
        code: '',
        header: '',
        description: ''
      }
    },
    button: {
      menuToggle: '',
      prev: '',
      next: '',
      removeFile: '',
      scroll: '',
      scrollUp: '',
      scrollDown: '',
      fullscreenOpen: '',
      fullscreenClose: '',
      contrastMode: '',
      productBack: '',
      close: '',
      view: '',
      back: '',
      fontUp: '',
      fontDown: '',
      language: '',
      categoriesAll: '',
      menuMusuem: '',
      menuFoundaiton: '',
      menuVirtual: '',
      menuCentrum: '',
      seeCollection: '',
      seeMore: ''
    },
    loader: {
      header: '',
      loading: ''
    }
  },
  activeCategory: 0,
  categories: [
    {
      name: 'telegraphs',
      image: telegraphsImage,
      imageStatic: telegraphsImageStatic,
      imageRest: telegraphsImageRest,
      slug: 'telegrafy'
    },
    {
      name: 'phones',
      image: phonesImage,
      imageStatic: phonesImageStatic,
      imageRest: phonesImageRest,
      slug: 'telefony'
    },
    {
      name: 'typewriters',
      image: typewritersImage,
      imageStatic: typewritersImageStatic,
      imageRest: typewritersImageRest,
      slug: 'maszyny-do-pisania'
    },
    {
      name: 'copier',
      image: copierImage,
      imageStatic: copierImageStatic,
      imageRest: copierImageRest,
      slug: 'kopiarki'
    },
    {
      name: 'radios',
      image: radiosImage,
      imageStatic: radiosImageStatic,
      imageRest: radiosImageRest,
      slug: 'radia'
    },
    {
      name: 'cars',
      image: carsImage,
      imageStatic: carsImageStatic,
      imageRest: carsImageRest,
      slug: 'pojazdy'
    },
    {
      name: 'planes',
      image: planesImage,
      imageStatic: planesImageStatic,
      imageRest: planesImageRest,
      slug: 'samoloty'
    },
    {
      name: 'publications',
      image: publicationsImage,
      imageStatic: publicationsImageStatic,
      imageRest: publicationsImageRest,
      slug: 'wydawnictwa'
    },
    {
      name: 'others',
      image: othersImage,
      imageStatic: othersImageStatic,
      imageRest: othersImageRest,
      slug: 'inne'
    }
  ],
  currentProductId: 0,
  searchProducts: [],
  products: {
    '0': {}
  },
  filters: [],
  activeFilters: {},
  activeSearch: '',
  activeListItem: null
}
